export var buyLangMap = {
    zh: 'zh',
    en: 'en',
    jp: 'ja',
    ko: 'ko'
};
export var T_CAPTCHA_ID = '2070586963';
// 活动类型列表(10代金券/20折扣/30折扣加代金券/40自定义/50满返)
export var ACTIVITY_TYPE = {
    COUPON: '10',
    DISCOUNT: '20',
    DISCOUNT_AND_COUPON: '30',
    OTHER: '40',
    FULLBACK: '50'
};
export var INVITE_ID = '202207_cps_invite';
export var CUSTOMER_KEY = {
    NEW: 1,
    OLD: 2
};
export var GET_USER_INFO_URL = 'https://www.tencentcloud.com/account/user/ajax?action=getUserInfo';
export var GET_INTL_USER_TYPE_URL = 'https://www.tencentcloud.com/account/user/ajax?action=getIntlUserType';
